(function(){

  'use strict'

  angular
    .module('app')
    .directive('scrolled', ScrolledDirective)
    .directive('disableAfterScroll', DisableAfterScroll)
    .directive('slideArrow', SlideArrowDirective)
    .directive('sprite', SpriteDirective)
    .directive("compareTo", CompareToDirective);
  ;

  ////////////////////////////

  function ScrolledDirective($w) {
    var scrolled = {
      restrict : 'A',
      scope    : {
        remove: '=?scrolledRemove',
        offset: '=?scrolledOffset',
        remWindowH : '=?scrolledOffsetWindow'
      },
      link     : ScrolledDirectiveLink
    };

    return scrolled;

    ////////////////////////////

    function ScrolledDirectiveLink(scope, element, attrs) {
      scope.remove = angular.isDefined(scope.remove) ? scope.remove : false;
      scope.remWindowH = angular.isDefined(scope.remWindowH) ? !!scope.remWindowH : false;

      var d      = document;
      var e      = element[0];
      var w      = angular.element($w);

      w.bind('scroll resize load', checkScrolled);

      ////////////////////////////

      function checkScrolled(){
        var scroll = (d.documentElement && d.documentElement.scrollTop || d.body.scrollTop);

        scroll += typeof scope.offset == 'undefined' ? (d.documentElement.clientHeight) : scope.remWindowH ? window.innerHeight - scope.offset : scope.offset;

        if(e.offsetTop < scroll)
          element.addClass('scrolled');
        else if(scope.remove)
          element.removeClass('scrolled');
      };

    }
  }

  ScrolledDirective.$inject = ['$window'];

  ////////////////////////////

  function DisableAfterScroll(){

    return {
      restrict : 'A',
      link : DisableAfterScrollLink
    };

    ////////////////////////////

    function DisableAfterScrollLink(scope, iElement, iAttrs) {

      iElement.on('mousewheel DOMMouseScroll', afterScroll);

      return;

      ////////////////////////////

      function afterScroll(e){
        var e0 = e.originalEvent,
            delta = e.wheelDelta || -e.detail || e0.wheelDelta || -e0.detail;

        this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
        e.preventDefault();
      }

    }

  }

  ////////////////////////////

  function SlideArrowDirective($window, $timeout){

    var sad = {
      restrict : 'E',
      replace : 'true',
      scope : {
        width     : '=',
        height    : '=',
        numbers   : '=',
        pathSrc   : '=',
      },
      link : SlideArrowLinkDirective,
      controller : ['$scope', '$element', '$attrs', SlideArrowControllerDirective],
      controllerAs : 'SlideArrowCtrl',
      template : '<div class="slider-box p-r">\
        <div class="expand o-h"><div class="slider-container p-r">\
          <div class="slider p-r f-l" ng-repeat="slide in slides" style="width: {{ photosW }}%;">\
            <img ng-src="{{ slide }}" class="d-ib va-t" width="100%" style="max-height: 100%; max-width: 100%;" alt="" />\
            <a class="m-s-p v-p v-t" target="_blank" href="{{ slide }}"></a>\
        </div></div>\
        </div>\
        <div class="arrows p-a expand">\
          <div class="arrow p-a arrow-left" ng-click="SlideArrowCtrl.prev($event)"></div>\
          <div class="arrow p-a arrow-right" ng-click="SlideArrowCtrl.next($event)"></div>\
        </div>\
      </div>'
    };

    return sad;

    ////////////////////////////

    function SlideArrowLinkDirective(scope, element, attrs){

      angular
        .element($window)
        .on('load',setSize)
        .on('resize',setSize)
      ;

      scope.$watch('pathSrc', function(n, o){ if(n) calc(); });
      scope.$watch('width', function(n, o){ if(n) calc(); });
      scope.$watch('height', function(n, o){ if(n) calc(); });

      ////////////////////////////

      function calc(){
        var i = 0, slides = [];
        for(i; i < scope.numbers; i++)
          slides.push(scope.pathSrc + (i+1) + '.jpg');

        scope.slides = slides;
        scope.photosW = (100 / scope.numbers);
        element[0].children[0].children[0].style.left = '-0px';

        setSize();
      }

      function setSize(){
        $timeout(function(){
          var w = scope.width || element[0].parentNode.offsetWidth;
          element[0].style.width = w + 'px';
          element[0].children[0].children[0].style.width = (scope.numbers * w) + 'px';

          $timeout(function(){
            var h = scope.height || element[0].children[0].children[0].children[0].offsetHeight;

            element[0].children[0].children[0].style.height = h + 'px';
            element[0].style.height = h + 'px';
          });

          scope.parentWidth = w;
          element[0].children[0].children[0].style.left = -(scope.parentWidth * scope.currentSlide) + 'px';
        });
      }
    }


    function SlideArrowControllerDirective($scope, $element, $attrs){
      var c = this;
      $scope.currentSlide = 0;

      c.prev = prev;
      c.next = next;


      return c;

      ////////////////////////////

      function prev(e){
        e.preventDefault();
        if($scope.currentSlide - 1 < 0)
          $scope.currentSlide = $scope.numbers - 1;
        else
          $scope.currentSlide -= 1;

        $element[0].children[0].children[0].style.left = -($scope.parentWidth * $scope.currentSlide) + 'px';
      }
      function next(e){
        e.preventDefault();
        $scope.currentSlide = ($scope.currentSlide + 1)% $scope.numbers;
        $element[0].children[0].children[0].style.left = -($scope.parentWidth * $scope.currentSlide) + 'px';
      }

    }
  }

  SlideArrowDirective.$inject = ['$window', '$timeout'];

  ////////////////////////////

  function SpriteDirective($interval, $window, $timeout){

    var sd = {
      restrict : 'A',
      scope : {
        image : '@spriteImage',
        count : '=spriteCount',
        offset : '=spriteOffset',
        height : '=spriteHeight',
        interval : '=spriteInterval',
      },
      link : SpriteDirectiveLink,
      template : '<div class="round"></div><div class="round"></div><div class="p-a sprite-count">{{ s.current + 1 }} / {{ s.count }}</div>'
    };

    return sd;

    ////////////////////////////

    function SpriteDirectiveLink(scope, element){

      var fe = element[0].children[0];
      var se = element[0].children[1];
      var s = {
        current : 0,
        offset  : scope.offset,
        height  : scope.height || 250,
        count   : scope.count
      };

      scope.s = s;

      element.css({ position : 'relative' });

      style({
        backgroundImage : 'url(' + scope.image + ')',
        position : 'absolute',
        top : '0px', left : '0px'
      });

      clazz('expand');

      $interval(change, scope.interval);

      angular
        .element($window)
        .on('resize', resH)
        .on('load', resH)
      ;

      ////////////////////////////

      function resH(){
        var w, h, r;

        w = element[0].parentNode.offsetWidth;
        h = (s.height * w) / s.offset;

        element[0].style.width = w + 'px'
        element[0].style.height = h + 'px';
        style({ backgroundSize: (w * s.count) + 'px ' + h + 'px' });
      }

      function style(p, v){
        if(typeof p == 'object'){
          for(var _p in p){
            fe.style[_p] = p[_p];
            se.style[_p] = p[_p];
          }
        } else {
          fe.style[p] = v;
          se.style[p] = v;
        }
      }

      function clazz(c){
        fe.className += " " + c;
        se.className += " " + c;
      }

      function change(){
        s.current = (s.current + 1) % s.count;

        fe.style.backgroundPosition = -(s.current * element[0].parentNode.offsetWidth) + 'px 0px';
        se.style.opacity = 0;

        $timeout(function(){
          se.style.backgroundPosition = -(s.current * element[0].parentNode.offsetWidth) + 'px 0px';
          se.style.opacity = 1;
        }, 600)

      }
    }

  }

  SpriteDirective.$inject = ['$interval', '$window', '$timeout'];

  ////////////////////////////

  function CompareToDirective() {
    return {
      require: "ngModel",
      scope: {
        otherModelValue: "=compareTo"
      },
      link: function(scope, element, attributes, ngModel) {
        ngModel.$validators.compareTo = function(modelValue) {
          return modelValue == scope.otherModelValue;
        };

        scope.$watch("otherModelValue", function() {
          ngModel.$validate();
        });
      }
    };
  }

})();
